__turbopack_context__.v({
  "contentLayout": "IndiaDynamicContent-module__zH7k8W__contentLayout",
  "desktopOnly": "IndiaDynamicContent-module__zH7k8W__desktopOnly",
  "errorContainer": "IndiaDynamicContent-module__zH7k8W__errorContainer",
  "heroBanner": "IndiaDynamicContent-module__zH7k8W__heroBanner",
  "heroDescription": "IndiaDynamicContent-module__zH7k8W__heroDescription",
  "heroDot": "IndiaDynamicContent-module__zH7k8W__heroDot",
  "heroGradientOverlay": "IndiaDynamicContent-module__zH7k8W__heroGradientOverlay",
  "heroImage": "IndiaDynamicContent-module__zH7k8W__heroImage",
  "heroTextContainer": "IndiaDynamicContent-module__zH7k8W__heroTextContainer",
  "mainContent": "IndiaDynamicContent-module__zH7k8W__mainContent",
  "mobileOnly": "IndiaDynamicContent-module__zH7k8W__mobileOnly",
  "planCardAnchor": "IndiaDynamicContent-module__zH7k8W__planCardAnchor",
  "plansGrid": "IndiaDynamicContent-module__zH7k8W__plansGrid",
  "sectionContainer": "IndiaDynamicContent-module__zH7k8W__sectionContainer",
  "subcategoryHeader": "IndiaDynamicContent-module__zH7k8W__subcategoryHeader",
  "tabBar": "IndiaDynamicContent-module__zH7k8W__tabBar",
  "tabItem": "IndiaDynamicContent-module__zH7k8W__tabItem",
});
